
  <h2 mat-dialog-title *ngIf="isNewUser == true">Create User</h2> 
  <h2 mat-dialog-title *ngIf="isNewUser == false">Edit User</h2>

  <mat-dialog-content>
 
  <div style='color: brown; padding: 5px; font-weight: bold' *ngIf="loginError != ''">{{loginError}}</div>
 
    <form >

        <div class="form-group row">
            <div class="col-12">
                <div class="form-material">
                    <input type="text" class="form-control"  name="FirstName"  [(ngModel)]="user.FirstName">
                    <label for="login-username">First Name</label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-12">
                <div class="form-material">
                    <input type="text" class="form-control" name="LastName" [(ngModel)]="user.LastName">
                    <label for="login-password">Last Name</label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-12">
                <div class="form-material">
                    <input type="text" class="form-control"  name="UserName" [(ngModel)]="user.UserName">
                    <label for="">Email</label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-12">
                <div class="form-material">
                    <select class="form-control"  name="RoleId" [(ngModel)]="user.RoleId">
                        <option value="1">User</option>
                        <option value="98">Admin</option>
                        <option value="99">Super Admin</option>
                    </select>
                    <label for="">Role</label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-12">
                <div class="form-material">
                    <input type="checkbox" class="form-control"  name="IsActive" [(ngModel)]="user.IsActive">
                    <label for="">Is Active</label>
                </div>
            </div>
        </div>

        <div class="form-group row gutters-tiny">
            <div class="col-12 mb-10">

                <a *ngIf="isNewUser == false" class="btn btn-block  btn-noborder btn-rounded btn-alt-secondary" (click)="resetPassword()" >
                    Send Reset Password
                </a>

                <a class="btn btn-block btn-hero btn-noborder btn-rounded btn-alt-primary" (click)="save()" >
                    Save
                </a>
            </div>
        </div>


    </form>



    </mat-dialog-content>
